import global from '../utils/global.js'
import Page from './Page.js'

export default class TourPage extends Page {

    static instance

    constructor(parent) {

        if ( TourPage.instance ) return TourPage.instance
        super( 'tour' )
        this.parent = parent
        TourPage.instance = this
        global.views.push( this.view )

    }   

    afterEnter(){

        console.log("tour page")
        
    }

    afterLeave(){

       

    }

}
